import classNames from "classnames";
import { getRelativeUrl } from "~/utils/url";

/**
 * AttachmentImage
 *
 * This component is used to display an image
 *
 * @param {number} imageId The ID of the image to display.
 * @param {string} imagePosition (optional) The position of the image within its container.
 * @param {React.CSSProperties} style (optional) Additional styles to apply to the image.
 * @param {string} className (optional) Additional class names to apply to the image.
 * @returns {*} React JSX
 */
export function AttachmentImage({
  image,
  imagePosition,
  style,
  className,
}: {
  image?: { src: string; alt?: string };
  imagePosition?: string;
  style?: React.CSSProperties;
  className?: string;
}) {
  const styles: React.CSSProperties = {
    ...style,
    objectPosition: imagePosition,
  };

  const getUrl = (url: string) => {
    if (!url) return url;

    // since we host the site on a different domain we normally convert all urls to relative urls
    // the media offloader changes the url to point to the s3 bucket instead of the local site
    // in those cases, we don't want to convert the url to a relative url
    //
    // we also put Fastly in front of the s3 host behind www.charitynavigator.org/uploads
    // don't change these urls either
    if (
      url.includes("cn-wordpress-uploads") ||
      url.includes("www.charitynavigator.org/uploads")
    )
      return url;

    return getRelativeUrl(url);
  };

  return (
    <>
      {image && (
        <img
          className={classNames(className)}
          style={styles}
          src={getUrl(image.src)}
          alt={image.alt}
        />
      )}
    </>
  );
}
